import '../styles/mainForm.css'
import { useContext } from "react";
import AppContext from '../context/formContext'
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import StepThree from "./stepThree";
import StepFour from "./stepFour";
import ThankYou from "./thankYou";

const MainForm = () => {
     
    const {form} = useContext(AppContext)

    return ( 
        <main className="mainFormContainer">
            <div className="card">
            {form === 1 ? <StepOne /> :
             form === 2 ? <StepTwo /> :
             form === 3 ? <StepThree /> :
             form === 4 ? <StepFour /> :
             form === 5 ? <ThankYou /> :
            <p>Error...</p>}
            </div>
            <div className="bottom"></div>
        </main>
     );
}
 
export default MainForm;